export default __webpack_public_path__ + "static/media/button-empty-web-large.c0dd8cea.png";